import axios from './axios';

let baseUrl = '';
const trim = {};

const init = function(url) {
    // use init to set the baseUrl
    baseUrl = url;

    return trim;
};

trim.getTrims = function (page, pageSize) {
    return new Promise((resolve, reject) => {
        const query = `?page=${page}&pageSize=${pageSize}`;

        axios.get(baseUrl + 'getTrims' + query).then(function (res) {
            const data = res.data;

            resolve(data);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.getTrimsByQuery = function (userId, trimName, description, page, pageSize) {
    return new Promise((resolve, reject) => {
        let data = { userId, trimName, description, page, pageSize };

        axios.post(baseUrl + 'getTrimsByQuery', data).then(function (res) {
            let trims = res.data;

            resolve(trims);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.getTrim = function (trimId) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'getTrim/' + trimId).then(function (res) {
            let trim = res.data;

            resolve(trim);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.getTrimsCreatedByUser = function (userId, page, pageSize) {
    const query = `?page=${page}&pageSize=${pageSize}`;

    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'getTrimsCreatedByUser/' + userId + query).then(function (res) {
            let trims = res.data;

            resolve(trims);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.addNew = function (trimData) {
    return new Promise((resolve, reject) => {
        let data = {
            trimData,
        };

        axios.post(baseUrl + 'addNew', data).then(function (res) {
            let newAddedTrim = res.data;

            resolve(newAddedTrim);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.updateInfo = function (id, trimInfo) {
    return new Promise((resolve, reject) => {
        let data = {
            trimInfo,
        };

        axios.post(baseUrl + 'updateInfo/' + id, data).then(function (res) {
            let { data, errors } = res.data;

            if (errors) {
                reject(errors)
            }
            else {
                resolve(data);
            }

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.updateOpenedStatus = function (id, openedStatus) {
    return new Promise((resolve, reject) => {
        let data = {
            openedStatus,
        };

        axios.post(baseUrl + 'openedStatus/' + id, data).then(function (res) {
            let success = res.data;

            resolve(success);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.save = function (id, trimData) {
    return new Promise((resolve, reject) => {
        let data = {
            trimData,
        };

        axios.post(baseUrl + 'save/' + id, data).then(function (res) {
            let success = res.data;

            resolve(success);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.export = function (id, trimData, customerContext = null) {
    return new Promise((resolve, reject) => {
        let data = {
            trimData,
            customerContext, // Include customer context in the request
        };

        // Debug logging for customer context in API layer
        console.log('🔍 API Export Debug - Sending to backend:');
        console.log(`   - Trim ID: ${id}`);
        console.log(`   - Customer Context:`, customerContext);
        
        axios.post(baseUrl + 'export/' + id, data).then(function (res) {
            let success = res.data;

            resolve(success);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.delete = function (id) {
    return new Promise((resolve, reject) => {
        axios.delete(baseUrl + 'delete/' + id).then(function (res) {
            let trimId = res.data;

            resolve(trimId);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

trim.search = function (query) {
    return new Promise((resolve, reject) => {
        let data = {
            query,
        };

        axios.post(baseUrl + 'search', data).then(function (res) {
            let trims = res.data;

            resolve(trims);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

export default init;